import type WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import type { CodeNavResponsePayload } from './types.js';

const ENCRYPTED_FIELDS = ['definition', 'definitions', 'references', 'symbols', 'confidentTarget'] as const;

export function sendCodeNavResponse(
  socket: WebSocket,
  e2ee: CliE2eeRuntime | undefined,
  payload: CodeNavResponsePayload,
): void {
  const fieldsToEncrypt = ENCRYPTED_FIELDS.filter((field) => field in payload && payload[field] !== undefined);
  sendWsMessage(
    socket,
    e2ee && fieldsToEncrypt.length > 0 ? e2ee.encryptFields(payload, [...fieldsToEncrypt]) : payload,
  );
}
